<template>
    <el-dialog :title="`[${viewData.sourceName}] ${viewData.name}${viewData.phone}`" :visible.sync="show" width="800px">
        <el-row :gutter="24">
            <div style="font-size: 13px; font-weight: 500; line-height: 30px">
                线索信息
            </div>
            <el-col :span="12">
                <el-row :gutter="20">
                    <el-col :span="8" class="form-label">姓名</el-col>
                    <el-col :span="12" class="form-value">
                        <div style="display: flex">
                            <div style="margin-right: 10px">
                                {{ viewData.name }}
                            </div>
                            <Desensitize :text="viewData.phone" :dataType="1" :clueId="viewData.id" :clearText="true" :key="viewData.id"/>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="12" v-for="item in clueInformation" :key="item.prop">
                <el-row :gutter="20">
                    <template v-if="typeof item.isEmptyShow == 'function' ?  item.isEmptyShow() : item.isEmptyShow">
                        <el-col :span="8" class="form-label">{{ item.label }}</el-col>
                        <el-col :span="12" class="form-value">
                            {{ item.formatter ? item.formatter(item) : viewData[item.prop] }}
                        </el-col>
                    </template>
                </el-row>
            </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
            <el-button @click="show = false">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { CONSTANT_0 } from '../js/form-options'
import { parseTime } from '@/utils/index'
export default {
    name: 'add-clue',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        viewData: {
            type: Object,
            default: () => { }
        },
    },
    watch: {
        visible(newVal) {
            this.show = newVal;
        },
        show(newVal) {
            this.$emit('update:visible', newVal);
        },
    },
    data() {
        return {
            CONSTANT_0,
            parseTime,
            show: false,
            clueInformation: [
                { prop: 'province', label: '归属地', isEmptyShow: true, formatter: (row) => `${this.viewData[row.prop]}/${this.viewData['city']}` },
                { prop: 'seriesName', label: '线索车型', isEmptyShow: () => this.viewData.seriesName !== '', formatter: (row) => `${this.viewData[row.prop]} ${this.viewData['specName']}` },
                { prop: 'sourceName', label: '来源渠道', isEmptyShow: true, },
                { prop: 'dealerName', label: '线索经销商名', isEmptyShow: () => this.viewData.dealerName !== '' },
                { prop: 'siteDesc', label: '来源描述', isEmptyShow: () => this.viewData.siteDesc !== '' },
                { prop: 'createTime', label: '线索留资时间', isEmptyShow: () => this.viewData.createTime !== '' },
                { prop: 'createdAt', label: '线索创建时间', isEmptyShow: () => this.viewData.createdAt !== '', formatter: (row) => parseTime(this.viewData[row.prop], "{y}-{m}-{d} {h}:{i}") },
                { prop: 'paymentMoney', label: '线上已付金额', isEmptyShow: () => (this.viewData.paymentMoney!== '' && this.viewData.paymentMoney !== CONSTANT_0), formatter: (row) => `${this.viewData[row.prop] / 100}元` },
                { prop: 'statusDisplay', label: '线索状态', isEmptyShow: () => this.viewData.statusDisplay !== '' },
                { prop: 'handleMemberName', label: '处理人员', isEmptyShow: () => this.viewData.handleMemberName !== '', formatter: (row) => this.viewData[row.prop] },
                { prop: 'updatedAt', label: '反馈时间', isEmptyShow: () => this.viewData.updatedAt !== '', formatter: (row) => parseTime(this.viewData[row.prop], "{y}-{m}-{d} {h}:{i}") },
                { prop: 'ownerName', label: '客户经理', isEmptyShow: () => this.viewData.ownerName !== '' },
                { prop: 'comments', label: '线索备注', isEmptyShow: () => this.viewData.comments !== '' },
            ],
        }
    },
    methods: {
    }
}
</script>